import { httpGet } from "@/api/connection";
import { Client, ClientOrganization } from "./clients.types";

export type GetClientsQuery = {
  client_id?: number;
  search?: string;
  page?: number;
  page_size?: number;
};

export type GetClientsResponse = {
  data: Client[];
  total: number;
  nextPage: number;
};

export type GetClientsFn = (
  options?: GetClientsQuery
) => Promise<GetClientsResponse>;

const getClients: GetClientsFn = async (options) => {
  return await httpGet("/clients", options);
};

export type GetClientOrgsResponse = ClientOrganization[];

export type GetClientOrgsFn = () => Promise<GetClientOrgsResponse>;

const getClientOrgs: GetClientOrgsFn = async () => {
  return await httpGet("/clients/organizations");
};

export const ClientsAPI = { get: getClients, getOrganizations: getClientOrgs };
